import { call, put, takeLatest, delay, select } from "redux-saga/effects";
import { productListSagaActionTypes } from "./saga-action";
import { axiosGraphqlInstance, axiosRestInstance } from "../../../common/axios";
import { productListSliceAction } from "../../slices/product-list";
import { AxiosResponse } from "axios";

const productMenuApi = async (sub_type: string) => {
  let response = axiosGraphqlInstance
    .post<
      AxiosResponse<{
        menu: {
          items: { title: string; url: string }[];
        };
      }>
    >("/graphql.json", {
      query: ` {
            menu(handle: "${sub_type}") {
            title
            items {
              title
              url
            }
          }
        }`,
      variables: {},
    })
    .then((response) => response.data.data);
  return response;
};

type productCollectionAPIResponseType = {
  success: boolean;
  message: string;
  collection: {
    id?: string;
    handle?: string;
    title?: string;
    description?: string;
    products?: {
      nodes?: {
        title?: string;
        id?: string;
        description?: string;
        descriptionHtml?: string;
        productType?: string;
        priceRangeV2?: {
          minVariantPrice?: {
            amount?: string;
            currencyCode?: string;
          };
          maxVariantPrice?: {
            amount?: string;
            currencyCode?: string;
          };
        };
        featuredImage?: {
          url?: string;
        };
        metafields: {
          nodes: Array<{
            key: string;
            value: string;
            definition: {
              name: string;
            };
          }>;
        };
        variants?: {
          edges?: {
            node?: {
              sku?: string;
              id?: string;
            };
          }[];
        };
        tags?: string[];
        sellingPlanGroups: {
          edges: {
            node: {
              sellingPlans: {
                edges: {
                  node: {
                    id: string;
                  };
                }[];
              };
            };
          }[];
        };
      }[];
    };
  };
};
const productCollectionApi = async (sub_package_type: string) => {
  let response = axiosRestInstance
    .get<AxiosResponse<productCollectionAPIResponseType>>(
      `/catalog/collection-by-handle/${sub_package_type}`
    )
    .then((res) => res.data);
  return response;
};

type getContractStatusListAPIResponseType = {
  success: boolean;
  message: string;
  data?: {
    ID: number;
    status: string;
    contract_name: string;
    sku: string;
    partner_id: number;
  }[];
};
const getContractStatusListAPI = async (partnerID: number) => {
  let response = axiosRestInstance
    .get<AxiosResponse<getContractStatusListAPIResponseType>>(
      `/contracts/allContractstatus/${partnerID}`
    )
    .then((res) => res.data);
  return response;
};

type getProductMetafieldOrderAPIResponseType = {
  success: boolean;
  message: string;
  data: Array<{
    value: string;
    metadata: Array<{
      key: string;
    }>;
    description: string;
  }>;
};
const getProductMetafieldOrderAPI = async () => {
  let response = axiosRestInstance
    .get<AxiosResponse<getProductMetafieldOrderAPIResponseType>>(
      `/lookupData/getlookupData/metafield`
    )
    .then((res) => res.data);
  return response;
};

// API Above --- Saga Below

function* getCollectionListSaga(actions: {
  type: string;
  payload: {
    subType: string;
  };
}) {
  try {
    yield put(productListSliceAction.setCollectionListLoading(true));
    let productMenuApiResponse: {
      menu: {
        items: { title: string; url: string }[];
      };
    } = yield call(productMenuApi, actions.payload.subType);
    yield put(
      productListSliceAction.setCollectionList(
        productMenuApiResponse.menu.items
      )
    );
    yield put(productListSliceAction.setCollectionListLoading(false));
  } catch (e) {
    console.log(e);
    yield put(productListSliceAction.setCollectionListLoading(false));
  }
}

function* getCollection(actions: {
  type: string;
  payload: {
    subType: string;
    subTypeIndex: number;
  };
}) {
  try {
    yield put(productListSliceAction.setLoadingStatus(true));
    let productMenuApiResponse: {
      menu: {
        items: { title: string; url: string }[];
      };
    } = yield call(productMenuApi, actions.payload.subType);
    let i: number = 0;
    let items: any = productMenuApiResponse.menu.items;
    while (items.length > i) {
      let result: productCollectionAPIResponseType = yield productCollectionApi(
        items[i].url.split("/")[items[i].url.split("/").length - 1]
      );
      yield put(
        productListSliceAction.setCollection({
          subType: actions?.payload?.subType,
          subTypeIndex: actions?.payload?.subTypeIndex,
          data: result.collection,
        })
      );
      i++;
    }
    yield put(productListSliceAction.setLoadingStatus(false));
  } catch (e) {
    console.log(e);
    yield put(productListSliceAction.setLoadingStatus(false));
  }
}

function* getContractStatusListSaga(actions: {
  type: string;
  payload: {
    partnerID: number;
  };
}) {
  try {
    let response: getContractStatusListAPIResponseType = yield call(
      getContractStatusListAPI,
      actions.payload.partnerID
    );
    yield put(
      productListSliceAction.setContractStatusList(response.data ?? [])
    );
  } catch (e) {
    console.log(e);
  }
}

function* getProductMetafieldOrderSaga() {
  try {
    yield put(productListSliceAction.setMetafieldKeyOrderLoading(true));
    
    let response: getProductMetafieldOrderAPIResponseType = yield call(
      getProductMetafieldOrderAPI
    );
    
    if (response.success && response.data && response.data.length > 0) {
      yield put(
        productListSliceAction.setMetafieldKeyOrder(response.data)
      );
    }
  } catch (e) {
    console.log(e);
  } finally {
    yield put(productListSliceAction.setMetafieldKeyOrderLoading(false));
  }
}

function* productListSaga() {
  yield takeLatest(
    productListSagaActionTypes.callGetCollectionListSaga,
    getCollectionListSaga
  );
  yield takeLatest(
    productListSagaActionTypes.callGetCollectionSaga,
    getCollection
  );
  yield takeLatest(
    productListSagaActionTypes.callGetContractStatusListSaga,
    getContractStatusListSaga
  );
  yield takeLatest(
    productListSagaActionTypes.callGetProductMetafieldOrderSaga,
    getProductMetafieldOrderSaga
  );
}

export default productListSaga;
